import React from 'react'

import { FormattedMessage } from 'react-intl'
import { useLocation } from 'react-router-dom'

import { SideBarBlockItem } from '@components/UI/SideBar'
import { TrackedRoute } from '@components/UI/TrackedRoute'
import { useMobileMenuControls } from '@context/MobileMenuControls'
import { BrandFanFilters, EventTrackingNames, PageRoutes } from '@enums'
import { IBrandFanStats } from '@store/brandFans'
import { isActiveMenu } from '@utils/urls'

interface IProps {
  stats: IBrandFanStats
}

const BrandFansFiltersGroups: React.FC<IProps> = ({ stats }) => {
  const { hideMobileMenu } = useMobileMenuControls()
  const { pathname } = useLocation()
  const count = stats[BrandFanFilters.Groups]
  return (
    <TrackedRoute
      eventName={EventTrackingNames.BrandFansViewGroupsList}
      properties={{ number_of_groups: count }}
    >
      <SideBarBlockItem
        key="brand-fan-groups"
        to={{
          pathname: PageRoutes.BrandFanGroups,
        }}
        count={count}
        text={<FormattedMessage id="brandFans.sidebar.filter.groups" />}
        active={isActiveMenu(pathname, PageRoutes.BrandFanGroups)}
        onClick={hideMobileMenu}
      />
    </TrackedRoute>
  )
}

export { BrandFansFiltersGroups }
export default BrandFansFiltersGroups
